import { graphql, commitMutation } from 'react-relay/legacy';
import { ConnectionHandler } from 'relay-runtime';

const mutation = graphql`
    mutation SharedSaveSearchMutation(
        $searchTypes: [types]
        $searchPages: [String]
        $input: FavoritePageInput!
    ) {
        favoritePage(input: $input) {
            user {
                savedSearches: favorites(first: 1, types: $searchTypes, pages: $searchPages)
                    @connection(key: "SharedSaveSearch_savedSearches", filters: []) {
                    edges {
                        node {
                            serviceId
                        }
                    }
                }
            }
        }
    }
`;

function commit(
    environment,
    { page, name, favoritedSearchId, type = 'SEARCH', favoriteRelayId, connectionKey, ...props }
) {
    const input = {
        page,
        type,
        name,
        userId: props.userId,
        favoriteId: favoritedSearchId,
        action: favoritedSearchId ? 'REMOVE' : 'ADD',
    };

    commitMutation(environment, {
        mutation,
        variables: {
            input,
            searchPages: page ? [page] : null,
            searchTypes: type ? [type] : null,
        },
        onCompleted: props.onCompleted,
        onError: props.onError,
        updater(store) {
            /**
             * Attempt to update relay store right after the mutation, instead of relying on a
             * refetch query.
             *
             * See relay docs from a better idea of the API
             * https://relay.dev/docs/guided-tour/updating-data/graphql-mutations/#updater-functions
             */
            if (connectionKey) {
                /**
                 * First, get the favorites connection that is already in the store and it is the
                 * one we will want to update.
                 */
                const viewer = store.getRoot().getLinkedRecord('viewer');
                const user = viewer && viewer.getLinkedRecord('user', { userId: props.userId });
                const favoritesConnection = ConnectionHandler.getConnection(user, connectionKey);

                /**
                 * Then we look at the response of the mutation.
                 */
                const payloadConnection = ConnectionHandler.getConnection(
                    store.getRootField('favoritePage').getLinkedRecord('user'),
                    'SharedSaveSearch_savedSearches'
                );
                const payloadEdges = payloadConnection.getLinkedRecords('edges');
                if (payloadEdges.length) {
                    /**
                     * If the response returned a new favorite objects, we know that the user
                     * intended to follow a new page and we will add it to the store.
                     */
                    const newEdge = ConnectionHandler.buildConnectionEdge(
                        store,
                        favoritesConnection,
                        payloadEdges[0]
                    );
                    ConnectionHandler.insertEdgeBefore(favoritesConnection, newEdge);
                } else {
                    /**
                     * If the response did not return any new objects, we know that the intention
                     * was to remove an existing favorites, so we'll just delete it from the store.
                     */
                    ConnectionHandler.deleteNode(favoritesConnection, favoriteRelayId);
                }
            }
        },
    });
}

export const SharedSaveSearch = {
    commit,
};
